<template>
  <v-app class="aa1">
    <v-main>
      <my-salary></my-salary>
    </v-main>
  </v-app>
</template>

<script>
//import HelloWorld from "./components/HelloWorld";
import MySalary from "@/components/MySalary";

export default {
  name: "App",

  components: {
    MySalary
  },

  data: () => ({
    //
  })
};
</script>

<style scoped>
.aa1 {
  /* background-color: #efefdf !important; */
  /* background-color: rgb(53, 104, 89) !important; */
  /* background-color: rgb(16, 41, 33) !important; */
  background-color: rgb(240, 240, 240) !important;
}
</style>
